import { Code as Key } from 'constants/keyboard';
import { WIDGET_MENU_OPTIONS } from 'types/WidgetMenu.types';
import { AccessibilityViewIndex } from 'types/accessibilityViewIndex';

import { DownloadModalTrigger } from './editorSettingsSlice.types';
import { RootState } from './store';

const selectColorVisionMode = (state: RootState) => state.editorSettings.colorVisionMode;
const selectLanguageUpdatedOnce = (state: RootState) => state.editorSettings.languageUpdatedOnce;
const selectActiveWidgetMenu = (state: RootState) => state.editorSettings.activeWidgetMenu;
const selectIsWidgetMenuActive = (state: RootState) =>
  state.editorSettings.activeWidgetMenu !== WIDGET_MENU_OPTIONS.NONE;
const selectReplaceWidgetMenuIndex = (state: RootState) => state.editorSettings.replaceWidgetMenuIndex;
const selectBrandIdx = (state: RootState) => state.editorSettings.brandIdx;
const selectKeyboardShortcutModalOpen = (state: RootState) => state.editorSettings.keyboardShortcutModalOpen;
const selectHasShowGrid = (state: RootState) => state.editorSettings.hasShowGrid;
const selectHasShowMargin = (state: RootState) => state.editorSettings.hasShowMargin;
const selectHasShowPrintBleed = (state: RootState) => state.editorSettings.hasShowPrintBleed;
const selectZoom = (state: RootState): number => state.editorSettings.zoom;
const selectIsSlideView = (state: RootState): boolean => state.editorSettings.isSlideView;
const selectAccessibilityViewIndex = (state: RootState) => state.editorSettings.accessibilityViewIndex;
const selectIsWidgetSettingsView = (state: RootState): boolean => state.editorSettings.isWidgetSettingsView;
const selectIsAccessibilityView = (state: RootState): boolean =>
  state.editorSettings.accessibilityViewIndex !== AccessibilityViewIndex.CLOSED;
const selectHasKeyboardIgnore = (state: RootState): boolean => state.editorSettings.hasKeyboardIgnore;
const selectAllowedKeyboardKeys = (state: RootState): Key[] => state.editorSettings.allowedKeyboardKeys;
const selectIsDownloadModalOpen = (state: RootState): boolean => state.editorSettings.downloadModal.isOpen;
const selectDownloadModalTrigger = (state: RootState): DownloadModalTrigger =>
  state.editorSettings.downloadModal.trigger;
const selectOriginalEditorId = (state: RootState) => state.editorSettings.originalEditorId;
const selectChartSettingsTabIndex = (state: RootState) => state.editorSettings.chartWidgetSettingsTabIndex;
const selectIsTeamSharingEnabled = (state: RootState) => state.editorSettings.isTeamSharingEnabled;
const selectShowCollaborationWarning = (state: RootState) => state.editorSettings.showCollaborationWarning;
const selectIsUploading = (state: RootState) => state.editorSettings.isUploading;
const selectEditBackgroundView = (state: RootState) => state.editorSettings.editBackgroundView;
const selectIsShowAltTagOnCanvas = (state: RootState): boolean => state.editorSettings.showAltTagOnCanvas;
const selectHasEditedAltText = (state: RootState): boolean => state.editorSettings.hasEditedAltText;

const selectIsGatedFontUploadModalOpen = (state: RootState) => state.editorSettings.isGatedFontUploadModalOpen;
const selectForceHideWidgetControl = (state: RootState) => state.editorSettings.forceHideWidgetControl;
const selectIsScrollZooming = (state: RootState) => state.editorSettings.isScrollZooming;
const selectIsFlowModeEnabled = (state: RootState) => state.editorSettings.isFlowModeEnabled;
const selectIsPageNumberToolbarOpen = (state: RootState) => state.editorSettings.isPageNumberToolbarOpen;
const selectImagePanelTabIndex = (state: RootState) => state.editorSettings.imagePanelTabIndex;
const selectRecommendedIconPack = (state: RootState) => state.editorSettings.recommendedIconPack;
const selectHasRecommendedIconPack = (state: RootState) => !!state.editorSettings.recommendedIconPack;

export {
  selectHasEditedAltText,
  selectZoom,
  selectIsSlideView,
  selectAccessibilityViewIndex,
  selectIsAccessibilityView,
  selectHasKeyboardIgnore,
  selectAllowedKeyboardKeys,
  selectIsDownloadModalOpen,
  selectDownloadModalTrigger,
  selectOriginalEditorId,
  selectIsWidgetSettingsView,
  selectChartSettingsTabIndex,
  selectColorVisionMode,
  selectLanguageUpdatedOnce,
  selectActiveWidgetMenu,
  selectIsWidgetMenuActive,
  selectBrandIdx,
  selectKeyboardShortcutModalOpen,
  selectHasShowGrid,
  selectIsTeamSharingEnabled,
  selectShowCollaborationWarning,
  selectIsUploading,
  selectEditBackgroundView,
  selectHasShowMargin,
  selectReplaceWidgetMenuIndex,
  selectIsShowAltTagOnCanvas,
  selectIsGatedFontUploadModalOpen,
  selectForceHideWidgetControl,
  selectIsScrollZooming,
  selectIsFlowModeEnabled,
  selectIsPageNumberToolbarOpen,
  selectImagePanelTabIndex,
  selectRecommendedIconPack,
  selectHasRecommendedIconPack,
  selectHasShowPrintBleed,
};
